import type { TooltipProps } from 'recharts';
import styles from './tooltip.module.scss';

type Formatter = (value: number) => string;

export const ChartTooltip = ({
  active,
  payload,
  label,
  format,
}: TooltipProps<number, string> & { format?: Formatter }) => {
  if (!active || !payload?.length) {
    return null;
  }
  const fmt = format ?? ((value: number) => value.toLocaleString('en-GB'));
  return (
    <div className={styles.tooltip} role="status">
      {label ? <div className={styles.label}>{label}</div> : null}
      {payload.map((entry) => (
        <div key={String(entry.dataKey)} className={styles.row}>
          <span className={styles.swatch} style={{ background: entry.color }} />
          <span className={styles.name}>{entry.name}</span>
          <span className={styles.value}>{fmt(Number(entry.value ?? 0))}</span>
        </div>
      ))}
    </div>
  );
};

export const money = (value: number): string => `£${value.toLocaleString('en-GB')}`;
export const dollars = (value: number): string => `$${value.toLocaleString('en-US')}`;
